export default "__VITE_ASSET__BtTgoo1F__"